import React, {useState} from 'react'
import { navigate } from "gatsby"
import { Formik, Field, Form as Form2, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import styled from "@emotion/styled/macro"
import { theme, device } from './Theme'

// Encode for Netlify
function encode(data) {
    return Object.keys(data)
      .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
      .join('&')
  }
  // Schema for validation
const phoneRegExp = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/

const Schema = Yup.object().shape({
    first_name: Yup.string()
      .required("Please enter your first name."),
    last_name: Yup.string()
      .required("Please enter your last name."),
      phone_number: Yup.string()
      .required("Please enter your phone number.")
      .matches(phoneRegExp, 'Please enter your phone number in the following format: 555-555-5555'),
    email_address: Yup.string()
      .email("Please enter your email in the following format: example@sample.com")
      .required("Please enter your email address."),
    
  })

const Form = (props) =>{
 
    const FormContainer = styled.div`
    
    label{
        display: none;
    }
    .errorCss{
        margin: 15px 0;
      color: red;
      font-weight: 700;
    }
    .textContainer{
        margin: 2.9375rem 0 2.25rem 0;
        @media ${device.lg}{
            margin-top: 7.4375rem;
        }
    }
   
    input, textarea{
        width: 100%;
        background-color: transparent;
        padding: 1.1875rem 2.375rem;
        box-sizing: border-box;
        font-size: 1.125rem;
        color: ${theme.colors.light};
        border: none;
        border-bottom: 1px solid ${theme.colors.light};

        ::placeholder{
            color: ${theme.colors.light};
            font-size: 1.125rem;
        }
        &:focus{
            background-color: ${theme.colors.light};
            color: ${theme.colors.dark};
        }
        }

        button{
            background-color: ${theme.colors.dark};
            font-family: ${theme.fonts.altFont};
            text-transform: uppercase;
            font-weight: 700;
            font-size: 1.0625rem;
            padding: 1.5rem 5.25rem;
            appearance: none;
            border: none;
            letter-spacing: 1px;
            margin-top: 1.5625rem;
            transition: all 0.25s;

            &:hover{
                cursor: pointer;
                background-color: ${theme.colors.secondary};
                color: ${theme.colors.dark};
            }
            @media ${device.lg}{
                grid-column: 2;
                max-width: 16.6875rem;
                justify-self: end;
            }
        }
        .textAreaContainer{
            @media ${device.lg}{
                grid-column: 1 / span 2;
            }
        }
        form{
            @media ${device.lg}{
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-column-gap: 2.8125rem;
            }
        }
    `
    const [error, setError] = useState(false)
    function handleSubmit(values, setSubmitting, resetForm) {
        fetch("/", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: encode({
            "form-name": "request-service",
            ...values,
          }),
        })
        .then(() => {
          navigate("/thank-you/", {
            state: { submitted: true },
          })
        })
        .catch(() => {
          resetForm()
          setSubmitting(false)
          setError(true)
        })
      }
      
    return(
        <FormContainer>
            <div className="textContainer">
            <p className="heading">
                    {props.data.heading}
                </p>
                <p className="subheading">
                {props.data.subheading}
                </p>
            </div>
        <Formik
      initialValues={{
        first_name: "",
        last_name: "",
        email_address: "",
        phone_number: "",
        comments: "",
      }}
      validationSchema={Schema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        handleSubmit(values, setSubmitting, resetForm)
      }}
    >
{({ isSubmitting }) => (
     <Form2
     method="post"
     name="request-service"
     data-netlify="true"
     data-netlify-honeypot="bot-field"
   >
<input type="hidden" name="bot-field" />
    <input type="hidden" name="form-name" value="request-service" />
    <div className="inputContainer">
    <label htmlFor="firstName">First Name</label>
    <Field type="text" name="first_name" id="firstName" placeholder="First Name" required />
    <div className="errorCss">
           <ErrorMessage name="first_name" />
         </div>
    </div>
    <div className="inputContainer">
    <label htmlFor="lastName">Last Name</label>
    <Field type="text" name="last_name" id="lastName" placeholder="Last Name" required />
    <div className="errorCss">
           <ErrorMessage name="last_name" />
         </div>
    </div>
    <div className="inputContainer">
    <label htmlFor="emailAddress">Email Address</label>
    <Field type="email" name="email_address" id="emailAddress" placeholder="Email Address" required />
    <div className="errorCss">
           <ErrorMessage name="email_address" />
         </div>
    </div>
    <div className="inputContainer">
    <label htmlFor="phoneNumber">Phone Number</label>
    <Field type="tel" name="phone_number" id="phoneNumber" placeholder="Phone no" required />
    <div className="errorCss">
           <ErrorMessage name="phone_number" />
         </div>
    </div>
    <div className="inputContainer textAreaContainer">
    <label htmlFor="comments">Your Comments</label>
    <Field name="comments" id="comments" component="textarea" rows="3" placeholder="Your Comments" />
    </div>
    <button type="submit" disabled={isSubmitting}>Submit</button>
    {error && (
      <div>Something went wrong. Please try again!</div>
    )}
   </Form2>
)}
    </Formik>
        </FormContainer>
    )
}
export {Form}